// Hook: Fetches distinct filter-option values for the Workflow Table dropdowns.
// Wraps the codegen-generated useGetWorkflowFilterOptionsQuery with stable empty-array
// fallbacks so column defs render before options arrive from the server.

import { useGetWorkflowFilterOptionsQuery } from "#graphql/supergraphHooks";
import type { WorkflowColumnFilterOptions } from "../types";

export interface UseWorkflowFilterOptionsResult {
  filterOptions: WorkflowColumnFilterOptions;
  loading: boolean;
  error: Error | null;
}

const EMPTY_OPTIONS: WorkflowColumnFilterOptions = {
  statuses: [],
  workflowTypes: [],
  clients: [],
  assignees: [],
};

export function useWorkflowFilterOptions(): UseWorkflowFilterOptionsResult {
  const { data, loading, error } = useGetWorkflowFilterOptionsQuery({
    fetchPolicy: "cache-first",
  });

  return {
    filterOptions: data?.workflowFilterOptions ?? EMPTY_OPTIONS,
    loading,
    error: error ?? null,
  };
}
